<template>
  <v-select
    v-model="valueDirty"
    v-bind="$attrs"
    :items="items"
  />
</template>

<script>

  export default {
    name: 'YearSelect',
    props: {
      value: {
        type: String,
        default: null
      }
    },
    data() {
      return {
        items: [],
        currentYear: new Date().getFullYear()
      }
    },
    computed: {
      valueDirty: {
        get: function () {
          return this.value
        },
        set: function (val) {
          this.$emit('input', val)
        }
      }
    },
    created() {
      this.genItems()
    },
    methods: {
      genItems() {
        const children = []
        const selectedYear = this.value ? parseInt(this.value, 10) : this.currentYear
        const maxYear = selectedYear + 50
        const minYear = Math.min(maxYear, (selectedYear - 50))

        for (let year = minYear; year <= maxYear; year++) {
          children.push(year.toString())
        }

        this.items = children
      }
    }
  }
</script>
